var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-card',{attrs:{"title":"排名卡片","headStyle":{color:'#0064c2', fontWeight:'bold', backgroundImage: 'linear-gradient(#FFFFFF, #DCF1FD)'}}},[_c('a-table',{attrs:{"pagination":false,"columns":_vm.columns,"data-source":_vm.data,"align":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }